// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"694dfc9e","643":"d297b0f4","734":"a484f421","913":"6ddfd64d","932":"d3efd575"}[chunkId] + ".chunk.js";
};